// authSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { apiRequest, apiRequestImage } from '../_helpers/apiConfig'
import { toast } from 'react-toastify'

export const adminLogin = createAsyncThunk(
  'auth/adminLogin',
  async (credentials, { rejectWithValue }) => {
    try {
      const response = await apiRequest('POST', '/v1/admin/login', credentials)

      if (!response.data || !response.data.token) {
        throw new Error(response.message || 'Invalid credentials')
      }

      return response
    } catch (error) {
      // Return a rejected value with the error message
      return rejectWithValue(
        error.response?.data?.message || error.message || 'Login failed'
      )
    }
  }
)

//// admin login history==>>>>>>>>>>>>>
export const getLoginHistory = createAsyncThunk(
  'admin/getLoginHistory',
  async filters => {
    const response = await apiRequest(
      'POST',
      '/v1/admin/getLoginHistory',
      filters
    )
    return response
  }
)

/// user management apis->>>>>>>>>>>
export const fetchUsers = createAsyncThunk(
  'user/getUserList',
  async filters => {
    const response = await apiRequest('POST', '/v1/user/getUserList', filters)
    return response
  }
)

export const userStatusUpdateBlockActiveInActive = createAsyncThunk(
  'user/userStatusUpdateBlockActiveInActive',
  async (filters, { dispatch }) => {
    const { payload, refreshData } = filters
    const response = await apiRequest(
      'POST',
      '/v1/user/userStatusUpdateBlockActiveInActive',
      payload
    )

    if (response) {
      dispatch(fetchUsers(refreshData))
    }
    return response
  }
)

// App setting
export const createAppSetting = createAsyncThunk(
  'appSetting/createAppSetting',
  async filters => {
    const response = await apiRequest(
      'POST',
      '/v1/appSetting/createAppSetting',
      filters
    )
    return response
  }
)
export const getAppSettingList = createAsyncThunk(
  'appSetting/getAppSettingList',
  async filters => {
    const response = await apiRequest(
      'POST',
      '/v1/appSetting/getAppSettingList',
      filters
    )
    return response
  }
)
export const updateAppSetting = createAsyncThunk(
  'appSetting/updateAppSetting',
  async filters => {
    const response = await apiRequest(
      'POST',
      '/v1/appSetting/updateAppSetting',
      filters
    )
    return response
  }
)
export const updateAppSettingStatus = createAsyncThunk(
  'appSetting/updateAppSettingStatus',
  async filters => {
    const response = await apiRequest(
      'POST',
      '/v1/appSetting/updateAppSettingStatus',
      filters
    )
    return response
  }
)
export const deleteAppSetting = createAsyncThunk(
  'appSetting/deleteAppSetting',
  async filters => {
    const response = await apiRequest(
      'POST',
      '/v1/appSetting/deleteAppSetting',
      filters
    )
    return response
  }
)

//support
export const getTicketList = createAsyncThunk(
  'support/getTicketList',
  async filters => {
    const response = await apiRequest(
      'POST',
      '/v1/support/getTicketList',
      filters
    )
    return response
  }
)
export const replyMessageOnTicket = createAsyncThunk(
  'support/replyMessageOnTicket',
  async filters => {
    const response = await apiRequest(
      'POST',
      '/v1/support/replyMessageOnTicket',
      filters
    )
    return response
  }
)
export const getMessageOnTicketList = createAsyncThunk(
  'support/getMessageOnTicketList',
  async filters => {
    const response = await apiRequest(
      'POST',
      '/v1/support/getMessageOnTicketList',
      filters
    )
    return response
  }
)

//updatePassword
export const updatePasswordAdmin = createAsyncThunk(
  'admin/updatePasswordAdmin',
  async filters => {
    const response = await apiRequest(
      'POST',
      '/v1/admin/updatePasswordAdmin',
      filters
    )
    return response
  }
)

export const getContactList = createAsyncThunk(
  '/contact/getContactList',
  async filters => {
    const response = await apiRequest(
      'POST',
      '/v1/contact/getContactList',
      filters
    )
    return response
  }
)

//FAQs
export const createFaq = createAsyncThunk('faq/createFaq', async filters => {
  const response = await apiRequest('POST', '/v1/faq/createFaq', filters)
  return response
})
export const getFaqList = createAsyncThunk('faq/getFaqList', async filters => {
  const response = await apiRequest('POST', '/v1/faq/getFaqList', filters)
  return response
})
export const updateFaqStatus = createAsyncThunk(
  'faq/updateFaqStatus',
  async filters => {
    const response = await apiRequest(
      'POST',
      '/v1/faq/updateFaqStatus',
      filters
    )
    return response
  }
)
export const deleteFaq = createAsyncThunk('/faq/deleteFaq', async filters => {
  const response = await apiRequest('POST', '/v1/faq/deleteFaq', filters)
  return response
})
export const updateFaq = createAsyncThunk('/faq/updateFaq', async filters => {
  const response = await apiRequest('POST', '/v1/faq/updateFaq', filters)
  return response
})

//coming soon
export const createComingSoon = createAsyncThunk(
  'comingSoon/createComingSoon',
  async filters => {
    const response = await apiRequest(
      'POST',
      '/v1/comingSoon/createComingSoon',
      filters
    )
    return response
  }
)
export const createTermPolicy = createAsyncThunk(
  'termsPolicyController/addTermPolicy',
  async filters => {
    const response = await apiRequest(
      'POST',
      '/v1/termsPolicyController/addTermPolicy',
      filters
    )
    return response
  }
)
export const getComingSoonList = createAsyncThunk(
  'comingSoon/getComingSoonList',
  async filters => {
    const response = await apiRequest(
      'POST',
      '/v1/comingSoon/getComingSoonList',
      filters
    )
    return response
  }
)
//Termconditionpolicy

export const termsPolicylist = createAsyncThunk(
  'termsPolicylist/geallList',
  async filters => {
    const response = await apiRequest(
      'GET',
      '/v1/termsPolicyController/getAll',
      filters
    )
    return response
  }
)
export const updateComingSoonStatus = createAsyncThunk(
  'comingSoon/updateComingSoonStatus',
  async filters => {
    const response = await apiRequest(
      'POST',
      '/v1/comingSoon/updateComingSoonStatus',
      filters
    )
    return response
  }
)
export const createExpertOpinion = createAsyncThunk(
  'expertOpinion/createExpertOpinion',
  async filters => {
    const response = await apiRequest(
      'POST',
      '/v1/expertOpinion/createExpertOpinion',
      filters
    )
    return response
  }
)
export const getExpertOpinionList = createAsyncThunk(
  'expertOpinion/getExpertOpinionList',
  async filters => {
    const response = await apiRequest(
      'POST',
      '/v1/expertOpinion/getExpertOpinionList',
      filters
    )
    return response
  }
)
export const updateExpertOpinion = createAsyncThunk(
  'expertOpinion/updateExpertOpinion',
  async filters => {
    const response = await apiRequest(
      'POST',
      '/v1/expertOpinion/updateExpertOpinion',
      filters
    )
    return response
  }
)

export const deleteExpertOpinion = createAsyncThunk(
  'expertOpinion/deleteComingSoon',
  async filters => {
    const response = await apiRequest(
      'POST',
      '/v1/expertOpinion/deleteExpertOpinion',
      filters
    )
    return response
  }
)
export const deleteComingSoon = createAsyncThunk(
  'comingSoon/deleteComingSoon',
  async filters => {
    const response = await apiRequest(
      'POST',
      '/v1/comingSoon/deleteComingSoon',
      filters
    )
    return response
  }
)
export const deleteTermPolicy = createAsyncThunk(
  'termsPolicyController/delete',
  async filters => {
    const response = await apiRequest(
      'POST',
      '/v1/termsPolicyController/delete',
      filters
    )
    return response
  }
)
export const updateComingSoon = createAsyncThunk(
  'comingSoon/updateComingSoon',
  async filters => {
    const response = await apiRequest(
      'POST',
      '/v1/comingSoon/updateComingSoon',
      filters
    )
    return response
  }
)
export const updateTermPolicy = createAsyncThunk(
  'termsPolicyController/update',
  async filters => {
    const response = await apiRequest(
      'POST',
      '/v1/termsPolicyController/update',
      filters
    )
    return response
  }
)

export const uploadImage = createAsyncThunk(
  'comingSoon/uploadImage',
  async formData => {
    const response = await apiRequestImage(
      'POST',
      '/v1/comingSoon/uploadImage',
      formData
    )
    return response
  }
)


export const uploadVideo = createAsyncThunk(
  'user/uploadVideoAPI',
  async formData => {
    const response = await apiRequestImage(
      'POST',
      '/v1/user/uploadVideoAPI',
      formData
    )
    return response
  }
)

export const uploadMedia = createAsyncThunk(
  'user/uploadVideoAPI',
  async formData => {
    const response = await apiRequestImage(
      'POST',
      '/v1/user/uploadMediaFile',
      formData
    )
    return response
  }
)

//coin features
export const createCoinFeatures = createAsyncThunk(
  'coinFeatures/createCoinFeatures',
  async filters => {
    const response = await apiRequest(
      'POST',
      '/v1/coinFeatures/createCoinFeatures',
      filters
    )
    return response
  }
)
export const getCoinFeaturesList = createAsyncThunk(
  'coinFeatures/getCoinFeaturesList',
  async filters => {
    const response = await apiRequest(
      'POST',
      '/v1/coinFeatures/getCoinFeaturesList',
      filters
    )
    return response
  }
)
export const updateCoinFeatures = createAsyncThunk(
  'coinFeatures/updateCoinFeatures',
  async filters => {
    const response = await apiRequest(
      'POST',
      '/v1/coinFeatures/updateCoinFeatures',
      filters
    )
    return response
  }
)
export const deleteCoinFeatures = createAsyncThunk(
  'coinFeatures/deleteCoinFeatures',
  async filters => {
    const response = await apiRequest(
      'POST',
      '/v1/coinFeatures/deleteCoinFeatures',
      filters
    )
    return response
  }
)
export const updateCoinFeaturesStatus = createAsyncThunk(
  'coinFeatures/updateCoinFeaturesStatus',
  async filters => {
    const response = await apiRequest(
      'POST',
      '/v1/coinFeatures/updateCoinFeaturesStatus',
      filters
    )
    return response
  }
)

//roadmap
export const createRoadMap = createAsyncThunk(
  'roadMap/createRoadMap',
  async filters => {
    const response = await apiRequest(
      'POST',
      '/v1/roadMap/createRoadMap',
      filters
    )
    return response
  }
)
export const getRoadMap = createAsyncThunk(
  'roadMap/getRoadMapList',
  async filters => {
    const response = await apiRequest(
      'POST',
      '/v1/roadMap/getRoadMapList',
      filters
    )
    return response
  }
)
export const updateRoadMap = createAsyncThunk(
  'roadMap/updateRoadMap',
  async filters => {
    const response = await apiRequest(
      'POST',
      '/v1/roadMap/updateRoadMap',
      filters
    )
    return response
  }
)
export const deleteRoadMap = createAsyncThunk(
  'roadMap/deleteRoadMap',
  async filters => {
    const response = await apiRequest(
      'POST',
      '/v1/roadMap/deleteRoadMap',
      filters
    )
    return response
  }
)
export const updateRoadMapStatus = createAsyncThunk(
  'roadMap/updateRoadMapStatus',
  async filters => {
    const response = await apiRequest(
      'POST',
      '/v1/roadMap/updateRoadMapStatus',
      filters
    )
    return response
  }
)
export const replyEmail = createAsyncThunk(
  '/replyEmail/replyEmail',
  async filters => {
    const response = await apiRequest(
      'POST',
      '/v1/replyEmail/replyEmail',
      filters
    )
    return response
  }
)
export const replyHistoryEmailList = createAsyncThunk(
  '/replyEmail/replyHistoryEmailList ',
  async filters => {
    const response = await apiRequest(
      'POST',
      '/v1/replyEmail/replyHistoryEmailList',
      filters
    )
    return response
  }
)
export const replyEmailList = createAsyncThunk(
  '/replyEmail/replyEmailList',
  async filters => {
    const response = await apiRequest(
      'POST',
      '/v1/replyEmail/replyEmailList',
      filters
    )
    return response
  }
)

//transactionList
export const getInvestmentList = createAsyncThunk(
  '/swapBalanceHistory/getInvestmentList',
  async filters => {
    const response = await apiRequest(
      'POST',
      '/v1/swapBalanceHistory/getInvestmentList',
      filters
    )
    return response
  }
)
export const dashboardData = createAsyncThunk(
  '/dashboardData',
  async filters => {
    const response = await apiRequest(
      'POST',
      '/v1/admin/dashboardData',
      filters
    )
    return response
  }
)
const authSlice = createSlice({
  name: 'auth',
  initialState: {
    category: [],
    userList: [],
    userTotal: null,
    updateduserStatus: null,
    appSet: [],
    support: [],
    chatSupport: [],
    loginHistory: [],
    loginHistoryList: [],
    loginHistoryTotal: 0,
    categoryManagementList: [],
    ComingSoonListData: [],
    CoinFeaturesListData: [],
    roadMapDataList: [],
    replyEmailDataList: [],
    faqListData: [],
    notificationList: [],
    allUser: [],
    allServices: [],
    companyListData: [],
    replyHistoryOnEmailListData: [],
    replyEmailListData: [],
    getInvestmentListData: [],
    dashboardQueryData: [],
    getExpertOpinionListData: {},
    InvestTotal: null,
    total: null,
    loading: false,
    error: null
  },
  reducers: {
    logout(state) {
      state.user = null
      state.error = null
    }
  },
  extraReducers: builder => {
    builder
      .addCase(adminLogin.pending, state => {
        state.loading = true
        state.error = null
      })
      .addCase(adminLogin.fulfilled, (state, action) => {
        state.loading = false
        state.user = action.payload
        localStorage.setItem('accessToken', action.payload.data.token)
      })
      .addCase(adminLogin.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })
      .addCase(getAppSettingList.pending, state => {
        state.loading = true
        state.error = null
      })
      .addCase(getAppSettingList.fulfilled, (state, action) => {
        state.loading = false
        state.total = action.payload?.data?.total
        state.appSet = action.payload?.data?.list
      })
      .addCase(getAppSettingList.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message
      })

      .addCase(fetchUsers.pending, state => {
        state.loading = true
        state.error = null
      })
      .addCase(fetchUsers.fulfilled, (state, action) => {
        state.loading = false
        state.userTotal = action.payload?.data?.total || 0
        state.userList = action.payload?.data?.list || []
      })
      .addCase(fetchUsers.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message
      })

      .addCase(userStatusUpdateBlockActiveInActive.pending, state => {
        state.loading = true
        state.error = null
      })
      .addCase(
        userStatusUpdateBlockActiveInActive.fulfilled,
        (state, action) => {
          state.loading = false
          state.updateduserStatus = action.payload
          toast.success(action.payload.message || 'Status Update Successfully')
        }
      )
      .addCase(
        userStatusUpdateBlockActiveInActive.rejected,
        (state, action) => {
          state.loading = false
          state.error = action.error.message
        }
      )

      .addCase(getLoginHistory.pending, state => {
        state.loading = true
        state.error = null
      })
      .addCase(getLoginHistory.fulfilled, (state, action) => {
        state.loading = false
        state.loginHistoryList = action?.payload?.data?.list
        state.loginHistoryTotal = action?.payload?.data?.total
      })
      .addCase(getLoginHistory.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message
      })

      .addCase(getTicketList.pending, state => {
        state.loading = true
        state.error = null
      })
      .addCase(getTicketList.fulfilled, (state, action) => {
        state.loading = false
        state.total = action.payload.data.total
        state.support = action.payload.data.list
      })
      .addCase(getTicketList.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message
      })

      .addCase(getMessageOnTicketList.pending, state => {
        state.loading = true
        state.error = null
      })
      .addCase(getMessageOnTicketList.fulfilled, (state, action) => {
        state.loading = false
        state.total = action.payload.data.total
        state.chatSupport = action.payload.data
      })
      .addCase(getMessageOnTicketList.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message
      })

      .addCase(getFaqList.pending, state => {
        state.loading = true
        state.error = null
      })
      .addCase(getFaqList.fulfilled, (state, action) => {
        state.loading = false
        state.total = action.payload?.data?.total
        state.faqListData = action.payload.data
      })
      .addCase(getFaqList.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message
      })

      .addCase(getContactList.pending, state => {
        state.loading = false
        state.error = null
      })
      .addCase(getContactList.fulfilled, (state, action) => {
        state.loading = false
        state.total = action.payload?.data?.total
        state.contactUsList = action.payload.data
      })
      .addCase(getContactList.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message
      })

      .addCase(getComingSoonList.pending, state => {
        state.loading = true
        state.error = null
      })
      .addCase(getComingSoonList.fulfilled, (state, action) => {
        state.loading = false
        state.total = action.payload?.data?.total
        state.ComingSoonListData = action.payload.data
      })
      .addCase(getComingSoonList.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message
      })


      .addCase(termsPolicylist.pending, state => {
        state.loading = true
        state.error = null
      })
      .addCase(termsPolicylist.fulfilled, (state, action) => {
        state.loading = false
        state.totalcounttermpolicy = action.payload?.data?.total
        state.listcounttermpolicy = action.payload.data?.list
      })
      .addCase(termsPolicylist.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message
      })

      .addCase(getCoinFeaturesList.pending, state => {
        state.loading = true
        state.error = null
      })
      .addCase(getCoinFeaturesList.fulfilled, (state, action) => {
        state.loading = false
        state.total = action.payload?.data?.total
        state.CoinFeaturesListData = action.payload.data
      })
      .addCase(getCoinFeaturesList.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message
      })

      .addCase(getRoadMap.pending, state => {
        state.loading = true
        state.error = null
      })
      .addCase(getRoadMap.fulfilled, (state, action) => {
        state.loading = false
        state.total = action.payload?.data?.total
        state.roadMapDataList = action.payload.data
      })
      .addCase(getRoadMap.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message
      })
      .addCase(replyEmail.pending, state => {
        state.loading = true
        state.error = null
      })
      .addCase(replyEmail.fulfilled, (state, action) => {
        state.loading = false
        // state.total = action.payload.data.total;
        state.replyEmailDataList = action.payload.data
      })
      .addCase(replyEmail.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message
      })

      .addCase(replyHistoryEmailList.pending, state => {
        state.loading = true
        state.error = null
      })
      .addCase(replyHistoryEmailList.fulfilled, (state, action) => {
        state.loading = false
        state.replyHistoryOnEmailListData = action.payload
      })
      .addCase(replyHistoryEmailList.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message
      })

      .addCase(replyEmailList.pending, state => {
        state.loading = true
        state.error = null
      })
      .addCase(replyEmailList.fulfilled, (state, action) => {
        state.loading = false
        state.replyEmailListData = action.payload
      })
      .addCase(replyEmailList.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message
      })

      .addCase(getInvestmentList.pending, state => {
        state.loading = true
        state.error = null
      })
      .addCase(getInvestmentList.fulfilled, (state, action) => {
        state.loading = false
        state.getInvestmentListData = action.payload
        state.InvestTotal = action?.payload?.data?.total
      })
      .addCase(getInvestmentList.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message
      })

      .addCase(dashboardData.pending, state => {
        state.loading = true
        state.error = null
      })
      .addCase(dashboardData.fulfilled, (state, action) => {
        state.loading = false
        state.dashboardQueryData = action.payload.data
      })
      .addCase(dashboardData.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message
      })

      .addCase(getExpertOpinionList.pending, state => {
        state.loading = true
        state.error = null
      })
      .addCase(getExpertOpinionList.fulfilled, (state, action) => {
        state.loading = false
        state.getExpertOpinionListData = action.payload.data
      })
      .addCase(getExpertOpinionList.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message
      })

      .addCase(updateExpertOpinion.pending, state => {
        state.loading = true
        state.error = null
      })
      .addCase(updateExpertOpinion.fulfilled, (state, action) => {
        state.loading = false
        state.updateExpertOpinionData = action.payload.data
      })
      .addCase(updateExpertOpinion.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message
      })

      
  }
})

// Export the actions and reducer
export const { logout } = authSlice.actions
export default authSlice.reducer
